function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.56809 5.24986H8.16634V4.08319C8.16634 3.48119 8.21534 3.10203 9.07809 3.10203H9.58443C9.90643 3.10203 10.1678 2.84069 10.1678 2.51869V1.78719C10.1678 1.48211 9.93384 1.22136 9.62934 1.20094C9.27701 1.17703 8.92409 1.16594 8.57059 1.16653C6.98801 1.16653 5.83301 2.13311 5.83301 3.90761V5.24986H4.66634C4.34434 5.24986 4.08301 5.51119 4.08301 5.83319V6.99986C4.08301 7.32186 4.34434 7.58319 4.66634 7.58319L5.83301 7.58261V12.2499C5.83301 12.5719 6.09434 12.8332 6.41634 12.8332H7.58301C7.90501 12.8332 8.16634 12.5719 8.16634 12.2499V7.58144L9.43451 7.58086C9.73084 7.58086 9.97993 7.35861 10.0138 7.06403L10.1473 5.89969C10.1876 5.55378 9.91693 5.24986 9.56809 5.24986H9.56809Z",
  fill: "white"
});

var SvgFacebook = function SvgFacebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook.c84a2162.svg";
export { ForwardRef as ReactComponent };